import { InjectionToken } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ClientPlatformEnum } from "@models/core/client-type";

export const CLIENT_PLATFORM = new InjectionToken<
  BehaviorSubject<ClientPlatformEnum>
>("CLIENT_PLATFORM", {
  providedIn: "root",
  factory: () => new BehaviorSubject<ClientPlatformEnum>(null),
});
